export default [
  {
    id:'1',
    name:'产品',
    children:[
      {
        id:'1-2',
        name:'二氯',
      },
      {
        id:'1-3',
        name:'三氯三氯三氯三氯',
        children:[
          {
            id:'1-3-1',
            name:'200g片',
          },
          {
            id:'1-3-2',
            name:'50g片',
          }
        ]
      },
    ]
  },
  {
    id:'2',
    name:'文章',
  },
  {
    id:'3',
    name:'其他',
  },
]


